import React from 'react';

const stringToInitials = (nameOrEmail = '') => {
  const s = (nameOrEmail || '').trim();
  if (!s) return '?';
  const parts = s.split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  // try email local-part
  const local = s.includes('@') ? s.split('@')[0] : s;
  return local.slice(0, 2).toUpperCase();
};

const API_ROOT = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';
const API_ORIGIN = API_ROOT.replace(/\/api\/?$/, '');

const Avatar = ({ src, name, email, size = 36 }) => {
  const initials = stringToInitials(name || email);
  const dimension = typeof size === 'number' ? `${size}px` : size;
  let resolvedSrc = src;
  if (resolvedSrc && resolvedSrc.startsWith('/')) {
    resolvedSrc = `${API_ORIGIN}${resolvedSrc}`;
  }
  if (resolvedSrc) {
    return (
      <img
        src={resolvedSrc}
        alt={name || email || 'Profile'}
        className="rounded-full object-cover"
        style={{ width: dimension, height: dimension }}
        onError={(e) => { e.currentTarget.style.display = 'none'; }}
      />
    );
  }
  return (
    <div
      className="rounded-full bg-purple-100 text-purple-700 flex items-center justify-center font-semibold"
      style={{ width: dimension, height: dimension }}
      title={name || email}
    >
      {initials}
    </div>
  );
};

export default Avatar;
